<loading-spinner></loading-spinner>
<router-outlet></router-outlet>
<ng-template ngbModalContainer></ng-template>

